<template>
  <div>
    <div class="version5-head">
      <LayoutHeadBanner
        v-if="$store.state.selected_menu"
        :itemData="$store.state.selected_menu"
      />
    </div>
    <Breadcrumb />

    <InvestorsTabs
      v-if="
        _.get(
          $store.state.current_content,
          'secondary.InvestorsTabs.conf.enabled'
        ) == 1
      "
    />

    <div class="container layout-outer flex-box">
      <div class="layout-left">
        <LayoutContent
          :itemData="$store.state.current_content"
          v-if="$store.state.current_content"
        />

        <DownloadList
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.DropdownList.conf.enabled'
            ) == 1
          "
          :itemData="
            _.get(this.$store.state.current_content, 'secondary.DropdownList.data.0.smarttabs')
          "
        />
      </div>

      <intersect @enter="animate = true" >
        <div class="layout-right fadeUp" :class="animate ? 'animate' : ''">
          <HowToApply
            :itemData="
              _.get(
                $store.state.current_content,
                'secondary.usefull_tools_right.conf'
              )
            "
            v-if="
              _.get(
                $store.state.current_content,
                'secondary.usefull_tools_right.conf.enabled'
              ) == 1
            "
          />

          <ApplicationLinkBoxHigh
            v-if="
              _.get(
                this.$store.state.current_content,
                'secondary.custom_banner.conf.enabled'
              ) == 1
            "
            :itemData="
              _.get(this.$store.state.current_content, 'secondary.custom_banner')
            "
            style="margin-bottom: 25px"
          />
        </div>
      </intersect>
    </div>
    <ReasonsSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ReasonsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ReasonsSlider')
      "
      :noBg="'noBg'"
    />
    <MoreWaysForBanking />
  </div>
</template>

<script>
import LayoutHeadBanner from "@/components/LayoutHeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import InvestorsTabs from "@/components/InvestorsTabs";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import HowToApply from "@/components/HowToApply";
import LayoutContent from "@/components/LayoutContent";
import ApplicationLinkBoxHigh from "../components/ApplicationLinkBoxHigh";
import ReasonsSlider from "../components/ReasonsSlider";
import DownloadList from "@/components/DownloadList";
import Intersect from 'vue-intersect';
export default {
  components: {
    LayoutHeadBanner,
    Breadcrumb,
    InvestorsTabs,
    MoreWaysForBanking,
    HowToApply,
    ApplicationLinkBoxHigh,
    LayoutContent,
    ReasonsSlider,
    DownloadList,
    Intersect
  },
  data(){
    return{
      animate: false,
    }
  }
};
</script>
